import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { SxProps } from 'src/components/muiTheme/utils';
import { Theme } from 'src/components/muiTheme/utils';
import {
  fetchAllLocationsSorted,
  locationsAllQueryKey,
} from 'src/models/location/location';

import {
  BaseSelect,
  FormSelectProps,
  SelectProps,
  createFormSelect,
} from './BaseSelect';

type LocationSelectProps = Omit<SelectProps, 'options' | 'loading'> & {
  sx?: SxProps<Theme>;
  includeNoLocation?: boolean;
  idToString?: boolean;
};

export const LocationSelect: FC<LocationSelectProps> = ({
  includeNoLocation = false,
  idToString = false,
  ...props
}) => {
  // Dedicated key so a paginated `['locations']` caller (API default per=5)
  // cannot poison this select with a partial page.
  const { data: locations, isLoading } = useQuery({
    queryKey: locationsAllQueryKey,
    queryFn: fetchAllLocationsSorted,
    staleTime: 60000,
    gcTime: 60000,
    select: (data) => data.locations,
  });

  const options = [
    ...(includeNoLocation ? [{ id: '-1', label: 'No location' }] : []),
    ...(locations?.map((location) => ({
      id: idToString ? String(location.id) : location.id,
      label: location.name,
    })) || []),
  ];

  return <BaseSelect {...props} options={options} loading={isLoading} />;
};

export const FormLocationSelect = createFormSelect<
  FormSelectProps & {
    idToString?: boolean;
  }
>(LocationSelect);
